import React from "react";
import { GET_LIST, Link } from "react-admin";
import { Card, CardContent, Button, CardHeader } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Warning from "@material-ui/icons/Warning";
import RentalPopOver from "../components/rentalPopOver";
import {
  map,
  curry,
  filter,
  isNil,
  assoc,
  propEq,
  find,
  range,
  when,
  complement,
  prop,
  sortBy,
  sortWith,
  ascend,
  path,
  head,
  uniq,
  indexOf,
} from "ramda";
import * as R from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import BikeInformationButton from "./bikeInformation";
import { parse } from "query-string";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

const StyledMonetizationOn = styled(MonetizationOn)`
  height: 18px !important;
`;

const StyledError = styled(Warning)`
  height: 18px !important;
`;

const StyledLink = styled(Link)`
  :link {
    color: #000000;
    text-decoration: underline;
  }
  :visited {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
  :active {
    color: #000000;
  }
`;

const Grid = styled.div({
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  maxWidth: "82vw",
  justifyContent: "flext-start"
});

const SpanRented = styled.span({
  color: "red",
  fontSize: "13px",
  fontWeight: "bolder"
});

const View = styled.span(props => ({
  color: props.color || "initial",
  fontWeight: props.weight || "normal",
  padding: "2px",
  backgroundColor: props.background,
  display: "inline-block",
  backgroundImage: props.shade
    ? "url(data:image/gif;base64,R0lGODlhDAAMAIAAAP///wAAACH5BAEAAAAALAAAAAAMAAwAAAIUhI8QmcvnnpImPstwo5Nq9EEcUAAAOw==)"
    : "none"
}));

const MainView = styled(View)(props => ({
  marginRight: "2px",
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const AuxView = styled(View)(props => ({
  minWidth: props.small ? "15%" : "29%",
  padding: "0px",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center"
}));

const Table = styled.div({
  display: "flex",
  overflow: "scroll",
  width: "90vw"
});

const KmSpan = styled.span({
  fontSize: "12px",
  fontWeight: "900",
  textDecoration: "underline",
  color: "red",
  backgroundColor: "white"
});

const Cell = props => {
  const {
    textValue,
    secundaryTextValue,
    color,
    secundaryColor,
    textColor,
    textWeight,
    weekend,
    smallAux,
    children,
    extraText,
    style
  } = props;
  return (
    <React.Fragment>
      <MainView
        background={color}
        color={textColor}
        weight={textWeight}
        shade={weekend}
        style={style}
      >
        {" "}
        {textValue} {children}&nbsp;<KmSpan>{extraText}</KmSpan>
      </MainView>
      <AuxView
        background={secundaryColor || color}
        shade={weekend}
        small={smallAux}
        style={style}
      >
        {" "}
        {secundaryTextValue}{" "}
      </AuxView>
    </React.Fragment>
  );
};

const DateColumn = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff"
}));

const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff",
  minWidth: "15rem",
  fontSize: "13px"
}));

const WeekDay = styled.div({
  width: "5.5rem"
});
const Date = styled.div({
  width: "7rem"
});

const Row = styled.div({
  display: "flex",
  height: "1.5rem",
  flexWrap: "nowrap",
  marginBottom: "2px",
  marginRight: "5px"
});

const BackButton = styled.div({
  marginBottom: "1rem"
});

const nilMap = R.when(R.complement(R.isNil));

const isWeekend = day => day.isoWeekday() === 6 || day.isoWeekday() === 7;

const duration = (rental) => {
  let days = moment(rental.date_2).diff(rental.date_1, 'days')
  if (rental.time_1 === '10:00:00' && rental.time_2 === '18:00:00') {
    days += 1
  } else if (rental.time_1 === '18:00:00' && rental.time_2 === '10:00:00') {
    days -= 1
  }
  return days || 0
}

const DISTANT_PAST = 0;
const DISTANT_FUTURE = 1e15;
let valorC = null
let miga = ''

const resolveLocation = (loc) => {
  if (Array.isArray(loc)) return loc[0] || {};
  return loc || {};
};

const clampToCursor = (rawDate, startLimit, cursor) => {
  let start = moment.max(moment(rawDate), moment(startLimit).startOf("day"));
  if (cursor && moment(cursor).isValid()) {
    const c = moment(cursor).startOf("day");
    if (c.isAfter(start, "day")) {
      start = c;
    }
  }
  return start;
};
class MotoSchedule extends React.Component {
  async getModels() {
    const dataProvider = await dataProviderFactory("rest");
    const models = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return models.data;
  }

  SetDate = (param) => {
    this.setState({
      dateV: moment(Date.parse(param)).format("YYYY-MM-DD")
    })
  }


  async getLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    return locations;
  }

  async getHolidays(startDate, endDate, location) {
    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
        location_id: location
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async fetchData(startDate, endDate, location, model) {
    const dataProvider = await dataProviderFactory("rest");
    const getDisplacedVehicles = dataProvider(GET_LIST, "displaced_vehicles", {
      filter: {},
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    const getItemLocations = dataProvider(GET_LIST, "item_locations", {
      filter: {
        type: "vehicle",
        endDate: moment(endDate).format("YYYYMMDD"),
        date: moment(startDate)
          // .endOf("month")
          .format("YYYYMMDD")
        // date: startDate.format("YYYYMMDD")
        // date: moment(endDate)
        //   .endOf("month")
        //   .format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const getItemLocationsDiff = dataProvider(GET_LIST, "item_locations_different", {
      filter: {
        type: "vehicle",
        endDate: moment(endDate).format("YYYYMMDD"),
        date: moment(startDate)
          // .endOf("month")
          .format("YYYYMMDD")
        // date: startDate.format("YYYYMMDD")
        // date: moment(endDate)
        //   .endOf("month")
        //   .format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const getVehicles = await dataProvider(GET_LIST, "bike_schedule", {
      filter: {
        schedule: true,
        include_events_start: startDate.format("YYYYMMDD"),
        include_events_end: endDate.format("YYYYMMDD"),
        vehicle_model_id: model
      },
      pagination: {
        page: 1,
        perPage: 9999
      },
      sort: {}
    });

    const [
      vehicles,
      locations,
      itemLocations, itemLocationsDiff,
      displacedVehicles
    ] = await Promise.all([
      getVehicles,
      this.getLocations(),
      getItemLocations, getItemLocationsDiff,
      getDisplacedVehicles
    ]);

    const updatedVehicles = map(
      v =>
        assoc(
          "displacement",
          this.isVehicleDisplaced(v, displacedVehicles),
          assoc(
            "location",
            this.locationForVehicle(
              v,
              locations.data,
              itemLocations.data,
            ),
            v
          )
        ),
      vehicles.data
    );

    const updatedVehiclesDiff = map(
      v =>
        assoc(
          "displacement",
          this.isVehicleDisplaced(v, displacedVehicles),
          assoc(
            "location",
            this.locationForVehicleDiff(
              v,
              locations.data,
              itemLocationsDiff.data,
            ),
            v
          )
        ),
      vehicles.data
    );

    if (location === 0) {
      //const byColor = R.ascend(R.prop('base_location'));
      const dataOrder = sortWith(
        [
          ascend(path(["model", "order"])),
          ascend(path(["location", "screen_order"])),
          ascend(prop("id"))
        ],
        updatedVehicles
      );
      return dataOrder
    }
    else {
     
      const specialVehicles = filter(
        obj =>
          R.isNil(obj.location) &&
          obj.base_location.base_location_id === location,
        // R.pathEq(["base_location", "base_location_id"], location),
        updatedVehicles
      );

      const vehiclesWithTransfers = filter(obj => {
        const sortedTransfers = sortBy(
          path(["transfer_date"]),
          filter(
            obj =>
              moment(obj.transfer_date).isSameOrBefore(endDate) &&
              moment(obj.transfer_date).isSameOrAfter(startDate),
            sortBy(path(["transfer_date"]), obj.transfers)
          )
        );

        // if (obj.id === 871) {
        //   // console.log(sortedTransfers);
        // }
        return (
          (!R.isNil(obj.location) &&
            R.prop("id", obj.location) !== location &&
            !R.isEmpty(sortedTransfers) &&
            // moment(
            //   R.prop("transfer_date", R.last(sortedTransfers))
            // ).isSameOrBefore(endDate) &&
            // moment(
            //   R.prop("transfer_date", R.last(sortedTransfers))
            // ).isSameOrAfter(startDate) &&
            R.prop("location_id_1", R.head(sortedTransfers)) === location) ||
          R.prop("location_id_2", R.head(sortedTransfers)) === location
        );
      }, updatedVehicles);

      const locationVehicles = R.filter(
        vehicle => !isNil(find(propEq("id", location), prop("location", vehicle))),
        updatedVehicles
      );

      const locationVehiclesDiff = R.filter(
        vehicle => !isNil(find(propEq("id", location), prop("location", vehicle))),
        updatedVehiclesDiff
      ); 
      let unionAll =  sortBy(
        path(["model", "order"]),
        locationVehicles.concat(locationVehiclesDiff)
      );

      const finalList = sortBy(
        path(["model", "order"]),
        unionAll.concat(specialVehicles).concat(vehiclesWithTransfers)
      );

      let hash = {};
      let result = sortBy(path(["id", "order"]),finalList)
      result = result.filter(o => hash[o.id] ? false : hash[o.id] = true);
    
      result = sortBy(path(["model", "order"]),result)

      return R.uniq(result);
    }
  }

  getRentalBlockColor(rental, start, end, day) {
    const halfDayColor = "#FFCC66";
    let baseBlockColor = "red";

    if (rental.from_agency || (rental.agency_id !== 2 && !R.isNil(rental.agency_id))) {
      baseBlockColor = "#FFFF00";
    }

    if (day.format("YYYY-MM-DD") === start.format("YYYY-MM-DD") && rental.time_1 === "18:00:00") {
      return halfDayColor;
    }

    if (day.format("YYYY-MM-DD") === end.format("YYYY-MM-DD") && rental.time_2 === "10:00:00") {
      return halfDayColor;
    }

    return baseBlockColor;
  }

  isVehicleDisplaced = (vehicle, displacedVehicles) => {
    const vehicleDisplaced =
      find(
        propEq("id", vehicle.id),
        R.propOr([], "data", displacedVehicles)
      ) || {};
    return {
      displaced: Boolean(vehicleDisplaced.displaced),
      displaceDate: vehicleDisplaced.displacedDate || null
    };
  };

  locationForVehicle = (vehicle, locations, itemLocations) => {
    // Known vehicle locations (given by events) in the selected time period
    const vehicleEventLocations = filter(propEq("item_id", vehicle.id), itemLocations);
    const vehicleEventLocationsIds = uniq(map(location => prop("location_id_2", location), vehicleEventLocations));
    // Get locations for the selected time period
    const vehicleLocations = filter(location => indexOf(prop("id", location), vehicleEventLocationsIds) > -1, locations)
    return vehicleLocations;
  };

  locationForVehicleDiff = (vehicle, locations, itemLocations) => {
    // Known vehicle locations (given by events) in the selected time period
    const vehicleEventLocations = filter(propEq("item_id", vehicle.id), itemLocations);
    const vehicleEventLocationsIds = uniq(map(location => prop("location_id_1", location), vehicleEventLocations));
    // Get locations for the selected time period
    const vehicleLocations = filter(location => indexOf(prop("id", location), vehicleEventLocationsIds) > -1, locations)
    return vehicleLocations;
  };

  async setData() {
    const {
      date_start,
      date_end,
      location,
      model,
      op_date_begin,
      op_date_end
    } = parse(this.props.location.search);
    const startDate = moment(date_start);
    const endDate = moment(date_end);
    const opDateBegin = !isNil(op_date_begin) ? moment(op_date_begin) : null;
    const opDateEnd = !isNil(op_date_end) ? moment(op_date_end) : null;

    // const reloading = false;
    await this.updateState(
      startDate,
      endDate,
      Number(location),
      model,
      opDateBegin,
      opDateEnd
    );
  }

  setReload() {
    this.setState({ reloading: true });
  }

  async componentDidUpdate(prevProps) {
    // const from = parse().from || null;
    if (this.props.location.search !== prevProps.location.search) {
      return await this.setData();
    }
  }

  async componentDidMount() {
    this.setData();
  }

  updateState = async (
    startDate,
    endDate,
    location,
    model,
    opDateBegin,
    opDateEnd
  ) => {
    const data = await this.fetchData(startDate, endDate, location, model);
    const models = await this.getModels();
    const locations = await this.getLocations();
    const holidays = await this.getHolidays(startDate, endDate, location);

    this.setState({
      reloading: false,
      data,
      startDate,
      endDate,
      location,
      model,
      models,
      holidays,
      locations: locations.data,
      opDateBegin,
      opDateEnd
    });
  };

  sortedDayList = (start, end, nextEventDate, forceAdd = false) => {
    const s = moment(start).startOf("day");
    const e = moment(end).startOf("day");
    const n = nextEventDate ? moment(nextEventDate).startOf("day") : null;
    const dayCount = e.diff(s, "days") + 1;
    const length =
      n && e.isSame(n, "day")
        ? dayCount - 1 + (forceAdd ? 1 : 0)
        : dayCount;
    return map(
      (offset) => s.clone().add(offset, "days"),
      range(0, Math.max(0, length))
    );
  };

  checkHoldType = holdType => {
    switch (holdType) {
      case 0:
        return "H";
      case 1:
        return "H";
      case 2:
        return "R";
      case 3:
        return "H";
      default:
        break;
    }
  };

  blockForHoldEvent = (
    hold,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    clampStart = null
  ) => {
    const start = clampToCursor(hold.start_date, startLimit, clampStart);

    const end = R.reduce(moment.min, moment(DISTANT_FUTURE), [
      moment(hold.end_date),
      endLimit,
      nilMap(moment, nextEventDate) || moment(DISTANT_FUTURE)
    ]);

    if (start.isAfter(end, "day")) return [];

    const days = this.sortedDayList(start, end, nextEventDate);

    const retirementDate = nilMap(moment, prop("retirement_date", vehicle));

    const isRetirement =
      retirementDate && retirementDate.isSame(hold.start_date, "day");

    const cell = day => {
      if (isRetirement) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                H: {this.buildLinkForHold(hold, vehicle.licence_plate)}
              </React.Fragment>
            }
            //secundaryTextValue={"S"}
            secundaryTextValue={
              <StyledMonetizationOn
                titleAccess={`Bike for Sale - ${moment(
                  vehicle.retirement_date
                ).format("YYYY-MM-DD")}`}
              />
            }
            color={"#FF00CC"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          />
        );
      }
      return (
        <Cell
          extraText=""
          textValue={
            <React.Fragment>
              H: {this.buildLinkForHold(hold, vehicle.licence_plate)}
            </React.Fragment>
          }
          //secundaryTextValue={"R"}
          secundaryTextValue={this.checkHoldType(hold.hold_type)}
          color={"#FF00CC"}
          weekend={isWeekend(day)}
          smallAux={true}
          style={{
            borderBottom: day.isSame(moment(opDateEnd)) ? "3px dashed red" : "",
            borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
          }}
        />
      );
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={hold.id} key={`${locat}_${vehicle.id}_${day}`}>{cell(day)}</Row>, days);
  };

  buildLinkTourRental = (rental, title) => {
    return (
      <StyledLink
        to={{
          pathname: `/${rental.type === 2 ? "rental_clients" : "tour_clients"
            }/${rental.id}/show`,
          search: `?from=${miga}`,
          state:{ miga: miga }
        }}
        state={{ miga: miga }}
        //target="_blank"
      >
        {title}
      </StyledLink>
    );
  };

  buildLinkForTransfer = (tranfer, title) => {
    return (
      <StyledLink to={{ 
        pathname: `/transfers/${tranfer.id}`, 
        search: `?from=${miga}`, 
        state:{ miga: miga }
      }}
      state={{ miga: miga }}
      target="_blank"
      >
        {title}
      </StyledLink>
    );
  };

  buildLinkForHold = (hold, title) => {
    return (
      <StyledLink to={{ 
          pathname: `/holds/${hold.id}`, 
          search: `?from=${miga}`, 
          state:{ miga: miga }
        }}
        state={{ miga: miga }}
        target="_blank"
        >
        {title}
      </StyledLink>
    );
  };

  buildLinkForTourGuide = (tour, title) => {
    return (
      <StyledLink to={{ 
          pathname: `/tours/${tour.id}`, 
          search: `?from=${miga}`, 
          state:{ miga: miga }
        }}
        state={{ miga: miga }}
        //target="_blank"
        >
        {title}
      </StyledLink>
    );
  };

  blockForRental = (
    rental,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    skipFirstDay = false,
    clampStart = null
  ) => {

    const originalStart = moment.max(moment(rental.date_1), startLimit);
    const start = clampToCursor(rental.date_1, startLimit, clampStart);
    const end = moment.min(moment(rental.date_2), endLimit);

    if (start.isAfter(end, "day")) return [];

    const days = this.sortedDayList(start, end, nextEventDate, true);
    const overlapsWithNextEvent = (day) => moment(day).isSame(nextEventDate, 'day');

    if (skipFirstDay && start.isSame(originalStart, "day")) {
      days.shift();
    }

    const isTour = R.propEq("type", 1);
    const driver = R.prop("driver", rental);
    const booking = R.prop("booking", rental);
    const country = R.prop("country", driver);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");

      const displayNextRentalInformation = overlapsWithNextEvent(day);

      if (!isTour(rental)) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                R: {this.buildLinkTourRental(rental, rental.id)}{" "}
              </React.Fragment>
            }
            secundaryTextValue={
              <React.Fragment>
                {displayNextRentalInformation && <StyledError />}
                <RentalPopOver>
                  {booking.r_first_name} {booking.r_last_name}
                  {", "}
                  {prop("country", country)}
                  {", "}
                  {duration(rental)} days
                  {displayNextRentalInformation && (
                    <React.Fragment>
                      <br />
                      {"Next rental on this day:"}
                      <br />
                      {R.path(['booking', 'r_first_name'], nextEvent)} {R.path(['booking', 'r_last_name'], nextEvent)}
                      {", "}
                      {prop("country", country)}
                      {", "}
                      {R.isNil(nextEvent) ? 0 : duration(nextEvent)} days
                    </React.Fragment>

                  )}
                </RentalPopOver>
              </React.Fragment>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={this.getRentalBlockColor(rental, start, end, day)}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={!displayNextRentalInformation}
          ></Cell>
        );
      } else {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                T: {this.buildLinkTourRental(rental, rental.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                **{" "}
                {path(["booking", "tour", "tour_name", "tour_name_en"], rental)}{" "}
                -- {moment.utc(booking.tour.tour_start_date).format("MMM")}{" "}
                {moment.utc(booking.tour.tour_start_date).format("DD")}-
                {moment.utc(booking.tour.tour_end_date).format("DD")}{" "}
                {moment.utc(booking.tour.tour_end_date).format("YYYY")} **{" "}
                {booking.r_first_name} {booking.r_last_name}
                {", "}
                {prop("country", country)}
                {", "}
              </RentalPopOver>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={"#CC9999"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
          />
        );
      }
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={rental.id} key={`${locat}_${vehicle.id}_${day}`} >{cell(day)}</Row>, days);
  };

  blockForTransfer = (
    transfer,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    clampStart = null
  ) => {
    const start = clampToCursor(transfer.transfer_date, startLimit, clampStart);
    const end = moment.min(moment(transfer.setup_date), endLimit);

    if (start.isAfter(end, "day")) return [];

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      let locat = null
      for (let index = 0; index < vehicle.location.length; index++) {
        locat = vehicle.location[index].location3letter_name;
      }
      return (
        <Row id={transfer.id} key={`${locat}_${vehicle.id}_${day}`}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                Transfer: {this.buildLinkForTransfer(transfer, transfer.id)}
              </React.Fragment>
            }
            secundaryTextValue={<RentalPopOver>{transfer.notes}</RentalPopOver>}
            color={"#9966FF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  blockForGuideTour = (
    tour,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    description,
    opDateBegin,
    opDateEnd,
    clampStart = null
  ) => {
    const start = clampToCursor(tour.effective_start_date, startLimit, clampStart);
    const end = moment.min(moment(tour.effective_end_date), endLimit);

    if (start.isAfter(end, "day")) return [];

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      let locat = null
      for (let index = 0; index < vehicle.location.length; index++) {
        locat = vehicle.location[index].location3letter_name;
      }
      return (
        <Row id={tour.id} key={`${locat}_${vehicle.id}_${day}`}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                {description}: {this.buildLinkForTourGuide(tour, tour.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                ** {path(["tour_name", "tour_name_en"], tour)} --{" "}
                {moment(tour.effective_start_date).format("MMM")}{" "}
                {moment(tour.effective_start_date).format("DD")}-
                {moment(tour.effective_end_date).format("DD")}{" "}
                {moment(tour.effective_end_date).format("YYYY")} **{" "}
                {description}
              </RentalPopOver>
            }
            color={"#66CCFF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  daysForEvent = (
    { event, type, skipFirstDay },
    vehicle,
    nextEvent,
    nextEventDate,
    start,
    end,
    opDateBegin,
    opDateEnd,
    clampStart = null
  ) => {
    switch (type) {
      case "hold":
        return this.blockForHoldEvent(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd,
          clampStart
        );
      case "transfer":
        return this.blockForTransfer(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd,
          clampStart
        );
      case "rental":
        return this.blockForRental(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd,
          skipFirstDay,
          clampStart
        );
      case "guide_tour_bike":
        return this.blockForGuideTour(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          "Guide",
          opDateBegin,
          opDateEnd,
          clampStart
        );
      case "guide_tour_van":
        return this.blockForGuideTour(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          "Van",
          opDateBegin,
          opDateEnd,
          clampStart
        );
      default:
        return this.blockForRental(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd,
          skipFirstDay,
          clampStart
        );
    }
  };

  locationForEvent = ({ event, type }) => {
    switch (type) {
      case "hold":
        return null;
      case "transfer":
        return event.location_2;
      case "rental":
        return event.location_2;
      case "guide_tour_bike":
        return event.location_2;
      case "guide_tour_van":
        return event.location_2;
      default:
        return event.location_2;
    }
  };

  bikeAtBase = (
    vehicle,
    prevEventDate,
    nextEventDate,
    location,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    explicitRange = null
  ) => {
    location = resolveLocation(location);
    let start;
    let end;
    if (explicitRange) {
      start = moment(explicitRange.start).startOf("day");
      end = moment.min(
        moment(explicitRange.end).startOf("day"),
        moment(endLimit).startOf("day")
      );
    } else {
      start = moment.max(
        moment(prevEventDate || DISTANT_PAST).add(1, "day"),
        startLimit
      );
      end = moment.min(
        moment(nextEventDate || DISTANT_FUTURE).add(-1, "day"),
        endLimit
      );
    }

    if (start.isAfter(end, "day")) return [];

    const days = this.sortedDayList(start, end, nextEventDate, true);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");

      return (
        <Cell
          extraText=""
          textValue={
            !isNil(vehicle.retirement_date) &&
            moment(vehicle.retirement_date).isSameOrBefore(moment(start)) ? (
              <React.Fragment>
                H: {vehicle.licence_plate}
              </React.Fragment>
             ) : ( 
              <React.Fragment>
              {vehicle.licence_plate}{" "}
              {vehicle.renting && <SpanRented>&#9415;</SpanRented>}
              </React.Fragment>
             )
          }
          secundaryTextValue={
            !isNil(vehicle.retirement_date) &&
              moment(vehicle.retirement_date).isSameOrBefore(moment(start)) ? (
              <StyledMonetizationOn
                titleAccess={`Bike for Sale - ${moment(
                  vehicle.retirement_date
                ).format("YYYY-MM-DD")}`}
              />
            ) : (
              `${ (R.prop("location3letter_name", location) != undefined) ? R.prop("location3letter_name", location) : 'H'}`
            )
          }
          color={
            !isNil(vehicle.retirement_date) &&
            moment(vehicle.retirement_date).isSameOrBefore(moment(start)) ? (
              "#FF00CC"
              ) : ( 
                    R.prop("location3letter_name", location) != undefined ? "#99FF99" : '#FF00CC' )
          }
          secundaryColor={
            !isNil(vehicle.retirement_date) &&
            moment(vehicle.retirement_date).isSameOrBefore(moment(start)) ? (
              "#FF00CC"
              ) : ( 
             (R.prop("color", location) != undefined) ? R.prop("color", location) : '#FF00CC' )
            }
          weekend={isWeekend(day) || this.isHoliday(day)}
          smallAux={true}
          style={{
            borderBottom: isSameDayEnd ? "3px dashed red" : "",
            borderTop: isSameDayBegin ? "3px dashed red" : ""
          }}
        />
      );
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={vehicle.id} key={`${locat}_${vehicle.id}_${day}`}>{cell(day)}</Row>, days);
  };

  isHoliday = day => {
    const { holidays } = this.state;
    const hasHollidays = [];
    map(hd => {
      if (moment(hd.date).format("YYYY-MM-DD") === day.format("YYYY-MM-DD")) {
        hasHollidays.push(hd);
      }
    }, prop("data", holidays));
    return R.length(hasHollidays) > 0;
  };

  buildTimeline = (start, end, opDateBegin, opDateEnd) => {
    const days = this.sortedDayList(start, end);
    const rows = map(day => {
      return (
        <Row
          id={`${start.unix()}_${Math.random()}`}
          key={`${start.unix()}_${Math.random()}`}
        >
          <WeekDay
            key={`d_${day.format("dddd")}_${Math.random()}`}
            style={{
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin))
                ? "3px dashed red"
                : "",
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null
            }}
          >
            {day.format("dddd")}
          </WeekDay>
          <Date
            style={{
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null,
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          >
            {day.format("DD-MM-YYYY")}
          </Date>
        </Row>
      );
    }, days);
    const { model, location, } = this.state;
    miga = `moto_schedule?date_start=${start.format("YYYYMMDD")}&date_end=${end.format("YYYYMMDD"
    )}&location=${location}&model=${model}&op_date_begin=${opDateBegin.isValid() ? opDateBegin.format("YYYYMMDD") : null
      }&op_date_end=${opDateEnd.isValid() ? opDateEnd.format("YYYYMMDD") : null
      }` 
    return <DateColumn>{rows}</DateColumn>;
  };

  buildEvents = (vehicles, start, end, opDateBegin, opDateEnd, location) => {

    const locat = ['MAD', 'BAR', 'MAL', 'LIS', 'BIL'];
    const orden_modelo = ['G310R', 'F700GS-LOW', 'F750GS', 'F800GS', 'F850GS', 'F800GT', 'F900GS ADV', 'F900XR', 'S1000XR', 'R1250RS', 'R1250GS', 'R1250GSA', 'R1250RT', 'R1300GS', 'R1300RS', 'R1300GSA', 'R1300RT', 'K1600GT', 'Jumper'];

    const SortVehicleLocation = arr => {
      let newArray = [];

      arr.sort((left, right) => {
        return moment.utc(left.purchase_date).diff(moment.utc(right.purchase_date));
      });

      if (location === 0) {
        locat.forEach(base => {
          orden_modelo.forEach(modelo => {
            arr.forEach(data => { //ordenando por ubicaciones
              if (base === data.location[0].location3letter_name && modelo === data.model.model_name) {
                newArray.push(data)
              }
            });
          });
        });
      } else {
        orden_modelo.forEach(modelo => {
          arr.forEach(data => { //ordenando por ubicaciones
            if (modelo === data.model.model_name) {
              newArray.push(data)
            }
          });
        });
      }

      return newArray;
    };

    const result = SortVehicleLocation(vehicles);

    return map(
      curry(
        this.buildEventsForVehicle
      )
        (start, end, opDateBegin, opDateEnd),
      result
    );
  };

  buildEventsForVehicle = (
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    vehicle
  ) => {
    // abstracts events in a boxed record for easier sorting since date props have diferent keys, startDate and endDate functions returns the start date and end date for a given box
    const buildEventRecords = (events, type, startKey, endKey) =>
      map(event => ({ type, event, startKey, endKey }), events);
    const startDate = R.converge(R.prop, [R.prop("startKey"), R.prop("event")]);
    const endDate = R.converge(R.prop, [R.prop("endKey"), R.prop("event")]);
    const separateEvents = (vehicleRentals) => {
      const vehicleEvents = JSON.parse(JSON.stringify(vehicleRentals))
      vehicleEvents.rentals.forEach((rental) => {
        if (rental.type !== 1) return
        const tour = rental.booking && rental.booking.tour
        if (!tour) return

        // Tours: usar fechas del tour, no rental.effective_* (datos inconsistentes en rentals)
        const tourStart =
          tour.effective_start_date ||
          tour.tour_start_date ||
          rental.date_1
        const tourEnd =
          tour.effective_end_date ||
          tour.tour_end_date ||
          rental.date_2

        if (tourStart) {
          rental.date_1 = moment.utc(tourStart).format("YYYY-MM-DD")
        }
        if (tourEnd) {
          rental.date_2 = moment.utc(tourEnd).format("YYYY-MM-DD")
        }
      })
      return vehicleEvents
    }
    const rentals = separateEvents(vehicle)
    const events = R.unnest([
      buildEventRecords(
        vehicle.transfers || [],
        "transfer",
        "transfer_date",
        "setup_date"
      ),
      buildEventRecords(rentals.rentals || [], "rental", "date_1", "date_2"),
      buildEventRecords(vehicle.holds || [], "hold", "start_date", "end_date"),
      buildEventRecords(
        vehicle.tours || [],
        "guide_tour_bike",
        "effective_start_date",
        "effective_end_date"
      ),
      buildEventRecords(
        vehicle.van_tours || [],
        "guide_tour_van",
        "effective_start_date",
        "effective_end_date"
      )
    ]);
    const sortedEvents = R.sortBy(startDate, events);
    const eventsWithSkipFlags = sortedEvents.map((record, index) => {
      if (index === 0 || record.type !== "rental") return record;
      const prev = sortedEvents[index - 1];
      const prevEnd = moment.min(moment(endDate(prev)), endLimit);
      const nextStart = moment(startDate(record));
      if (prevEnd.isSame(nextStart, "day")) {
        return { ...record, skipFirstDay: true };
      }
      return record;
    });
    // transforms [a, b, c, d] in [[a, b], [b, c], [c, d], [d, null]]. this is usefull for mapping/reducing over while reading next event, also handles empty arrays
    const eventsTuples = R.concat(
      R.aperture(2, eventsWithSkipFlags),
      R.filter(R.identity, [nilMap(e => [e, null], R.last(eventsWithSkipFlags))])
    );

    const firstEventDate = nilMap(
      moment,
      nilMap(startDate, R.head(eventsWithSkipFlags))
    );

    const initialLocation = resolveLocation(vehicle.location);

    let cursor = moment(startLimit).startOf("day");
    const scheduleEnd = moment(endLimit).startOf("day");

    const initialEvents = (() => {
      if (R.isNil(firstEventDate) || firstEventDate.isAfter(startLimit, "day")) {
        const initialEnd = firstEventDate
          ? moment.min(firstEventDate.clone().subtract(1, "day"), scheduleEnd)
          : scheduleEnd;

        // Days before purchase_date are painted as hold (empty location => "H")
        let preRows = [];
        const purchaseDate = vehicle.purchase_date
          ? moment(vehicle.purchase_date).startOf("day")
          : null;
        if (purchaseDate && cursor.isBefore(purchaseDate, "day")) {
          const preEnd = moment.min(
            purchaseDate.clone().subtract(1, "day"),
            initialEnd
          );
          if (!cursor.isAfter(preEnd, "day")) {
            preRows = this.bikeAtBase(
              vehicle,
              null,
              null,
              {},
              startLimit,
              endLimit,
              opDateBegin,
              opDateEnd,
              { start: cursor, end: preEnd }
            );
            cursor = preEnd.clone().add(1, "day");
          }
        }

        if (!cursor.isAfter(initialEnd, "day")) {
          const rows = this.bikeAtBase(
            vehicle,
            null,
            null,
            initialLocation,
            startLimit,
            endLimit,
            opDateBegin,
            opDateEnd,
            { start: cursor, end: initialEnd }
          );
          cursor = initialEnd.clone().add(1, "day");
          return R.concat(preRows, rows);
        }
        return preRows;
      }
      return [];
    })();

    const [finalAcc, eventsBlocks] = R.mapAccum(
      (acc, [event, next]) => {
        const { location, cursor: currentCursor } = acc;
        let cursorLocal = moment(currentCursor).startOf("day");
        const nextEventDate = nilMap(startDate)(next);
        const lastLocation = resolveLocation(
          nilMap(this.locationForEvent)(event) || location
        );

        const eventStart = moment.max(
          moment(startDate(event)),
          moment(startLimit).startOf("day"),
          cursorLocal
        );
        const eventEnd = moment.min(moment(endDate(event)), scheduleEnd);

        let daysForEvent = [];
        if (!eventStart.isAfter(eventEnd, "day")) {
          daysForEvent = this.daysForEvent(
            event,
            vehicle,
            R.prop("event", next),
            nextEventDate,
            startLimit,
            endLimit,
            opDateBegin,
            opDateEnd,
            eventStart
          );
          cursorLocal = eventEnd.clone().add(1, "day");
        }

        const gapStart = cursorLocal.clone();
        const gapEnd = moment.min(
          nextEventDate
            ? moment(nextEventDate).subtract(1, "day")
            : scheduleEnd,
          scheduleEnd
        );

        let daysForBase = [];
        if (!gapStart.isAfter(gapEnd, "day")) {
          daysForBase = this.bikeAtBase(
            vehicle,
            null,
            null,
            lastLocation,
            startLimit,
            endLimit,
            opDateBegin,
            opDateEnd,
            { start: gapStart, end: gapEnd }
          );
          cursorLocal = gapEnd.clone().add(1, "day");
        }

        const r = R.unnest([daysForEvent, daysForBase]);
        return [{ location: lastLocation, cursor: cursorLocal }, r];
      },
      { location: initialLocation, cursor },
      eventsTuples
    );

    let trailingFill = [];
    if (!finalAcc.cursor.isAfter(scheduleEnd, "day")) {
      trailingFill = this.bikeAtBase(
        vehicle,
        null,
        null,
        finalAcc.location,
        startLimit,
        endLimit,
        opDateBegin,
        opDateEnd,
        { start: finalAcc.cursor, end: scheduleEnd }
      );
    }

    let cells = R.concat(initialEvents, R.unnest(eventsBlocks), trailingFill);

    if (R.isEmpty(cells)) {
      cells = this.bikeAtBase(
        vehicle,
        null,
        null,
        initialLocation,
        startLimit,
        endLimit,
        opDateBegin,
        opDateEnd,
        { start: moment(startLimit).startOf("day"), end: scheduleEnd }
      );
    }

    const firstRow = R.head(cells);
    const secondRow = cells.length > 1 ? cells[1] : firstRow;

    if (!firstRow || !secondRow) {
      return (
        <Column key={`${vehicle.id}_${vehicle.licence_plate}_empty`} />
      );
    }

    const shouldDisplayWarning = () => {
      return vehicle.displacement.displaced;
    };

    const newFirstRow = (
      <firstRow.type id={firstRow.props.id} key={`${firstRow.props.children.props.secundaryTextValue}_${firstRow.props.id}_t1-${vehicle.licence_plate}`} >
        <firstRow.props.children.type
          {...firstRow.props.children.props}
          extraText=""
          textValue={`${vehicle.model.model_name.replace("Citroen", "")}${vehicle.low ? "-L" : ""
            }`}
          secundaryTextValue={firstRow.props.children.props.secundaryTextValue}
          // secundaryTextValue={
          //   R.isNil(vehicle.location) ||
          //   (!R.isNil(vehicle.location) &&
          //     this.state.location === vehicle.location.id)
          //     ? firstRow.props.children.props.secundaryTextValue
          //     : `${vehicle.location.location3letter_name}`
          // }
          // secundaryColor={
          //   R.isNil(vehicle.location)
          //     ? firstRow.props.children.props.secundaryColor
          //     : `${vehicle.location.color}`
          // }
          textColor={"blue"}
          textWeight={"bold"}
        >
          <BikeInformationButton vehicle={vehicle} />

          {shouldDisplayWarning() ? <StyledError /> : ""}
        </firstRow.props.children.type>
      </firstRow.type>
    );

    const newSecondRow = (
      <secondRow.type id={secondRow.props.id} key={`${secondRow.props.children.props.secundaryTextValue}_${secondRow.props.id}_t2-${vehicle.licence_plate}`}>
        <secondRow.props.children.type
          {...secondRow.props.children.props}
          extraText=""
          textValue={`${vehicle.vehicle_mileage}km`}
          textColor={"red"}
          textWeight={"bold"}
        />
      </secondRow.type>
    );

    const cells2 = R.unnest([
      [newFirstRow],
      [newSecondRow],
      R.compose(R.tail, R.tail)(cells)
    ]);

    let elements = [];
    let cont = 1;
    cells2.forEach(element => {
      if (cont % 20 === 0) {
        const kms = path(
          ["props", "children", "props", "textValue"],
          newSecondRow
        );
        const model = path(
          ["props", "children", "props", "textValue"],
          newFirstRow
        );

        const newElement = React.cloneElement(element, {
          children: React.Children.map(element.props.children, (child, idx) => {
            if (idx === 0 && child) {
              return React.cloneElement(child, {
                extraText: `${model} - ${kms}`,
              });
            }
            return child;
          }),
        });

        elements.push(newElement);
      } else {
        elements.push(element);
      }
      cont += 1;
    });

    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return <Column key={`${locat}_${vehicle.id}_${vehicle.licence_plate}`}> {elements} </Column>;
  };

  render() {
    if (this.state === null || (this.state !== null && this.state.reloading)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }
    const timeline = this.buildTimeline(
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd
    );
    const events = this.buildEvents(
      this.state.data,
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd,
      this.state.location
    );
    const {
      model,
      startDate,
      endDate,
      models,
      locations,
      location,
      opDateBegin,
      opDateEnd
    } = this.state;

    const withModel = prop(
      "model_name",
      head(filter(propEq("id", parseInt(model, 0)), models))
    );

    const withLocation = prop(
      "location_name",
      head(filter(propEq("id", parseInt(location, 0)), locations))
    );

    return (
      <Card style={{ textAlign: "center" }}>
        <CardHeader
          title={`MOTO SCHEDULE (${model !== "0" ? withModel : "ALL MODELS"
            }) - ${location !== 0 ? withLocation.toUpperCase() : "ALL LOCATIONS"
            }`}
        />
        <CardContent>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              to={{
                pathname: `/moto_schedule/start`,
                search: `?date_start=${startDate.format(
                  "YYYYMMDD"
                )}&date_end=${endDate.format(
                  "YYYYMMDD"
                )}&location=${location}&model=${model}&op_date_begin=${opDateBegin.isValid() ? opDateBegin.format("YYYYMMDD") : null
                  }&op_date_end=${opDateEnd.isValid() ? opDateEnd.format("YYYYMMDD") : null
                  }`
              }}
            >
              Pick a different model/city/time period
            </Button>
          </BackButton>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              title="Back one month"
              onClick={() => this.setReload()}
              to={{
                pathname: `/moto_schedule`,
                search: `?date_start=${startDate
                  .clone()
                  .subtract(1, "month")
                  .format("YYYYMMDD")}&date_end=${endDate
                    .clone()
                    .subtract(1, "month")
                    .format(
                      "YYYYMMDD"
                    )}&location=${location}&model=${model}&op_date_begin=${opDateBegin.isValid()
                      ? opDateBegin.clone().subtract(1, "month").format("YYYYMMDD")
                      : null
                  }&op_date_end=${opDateEnd.isValid()
                    ? opDateEnd.clone().subtract(1, "month").format("YYYYMMDD")
                    : null
                  }`
              }}
            >
              <ArrowUpward />
            </Button>
          </BackButton>
          <Grid>
            {timeline}
            <Table>{events}</Table>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default MotoSchedule;



// WEBPACK FOOTER //
// ./src/components/motoSchedule.js